import { styled } from 'troyfe';

const Block = styled.div`
  height: calc(100% - 48px);
  box-sizing: border-box;
  overflow: auto;

  .ant-menu {
    background: #ffffff;
  }
  .ant-menu-submenu-selected {
    color: #44bb55 !important;
  }
  .ant-menu-submenu-title {
    padding-left: 16px !important;
  }
  .ant-menu-inline .ant-menu-submenu {
    padding: 0 12px;
  }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: #f1f2f4;
  }
  .ant-menu-inline .ant-menu-item-selected::after {
    opacity: 0;
  }
  .ant-menu-item {
    padding-left: 30px !important;
  }
  .organization {
    display: flex;
    align-items: center;
    padding: 20px 0 21px;
    min-height: 80px;
    position: relative;
    img {
      width: 28px;
      height: 28px;
      margin-left: 16px;
    }
    .organization_text {
      margin-left: 12px;
      width: 100%;
      h1 {
        font-weight: bold;
        font-size: 14px;
        color: #1b1b1d;
        position: relative;
        .switch {
          color: rgb(164, 164, 164);
          cursor: pointer;
          position: absolute;
          right: 6px;
          top: 0;
        }
      }
      .authentication {
        width: fit-content;
        margin-top: 5px;
        border-radius: 4px;
        font-size: 10px;
        padding: 1px 5px;
        text-align: center;
      }
    }

    ul::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    ul::-webkit-scrollbar-thumb {
      border-radius: 6px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgb(164, 164, 164);
    }
    ul::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 6px;
      background: #ededed;
    }
  }
  .line {
    height: 1px;
    width: 88%;
    margin: auto;
    background: #f1f2f4;
  }
  .shadow-box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 13;
    background: rgba(0, 0, 0, 0.4);
  }
  .shadow {
    position: absolute;
    top: 50%;
    left: 50%;
  }
`;
const DropdownStyle = styled.div`
    transition: ease-in 2s;
    position: absolute;
    overflow: hidden;
    background-color: #fff;
    width: 360px;
    height: 256px;
    left: 23px;
    top: -13px;
    z-index: 12;
    border-radius: 8px;
    box-shadow: 0 0 2px #087818;
    padding: 24px 16px 4px;
    ul {
      overflow-y: scroll;
      margin-top: 24px;
      height: 175px;
      img {
        width: 28px;
        height: 28px;
        margin-left: 0;
      }
      .organization_item {
        display: flex;
        align-items: center;
        border: 1px solid #e2e2e2;
        padding: 16px 0 15px 14px;
        border-radius: 8px;
        margin-bottom: 20px;
        .authentication {
          width: fit-content;
          margin-top: 5px;
          border-radius: 4px;
          font-size: 10px;
          padding: 1px 5px;
          text-align: center;
        }
        .organization_text {
          margin-left: 12px;
          width: 100%;
        }
        &:hover {
          cursor: pointer;
          border: 1px solid #44bb55;
        }
      }
    }
    .title {
      font-size: 20px;
      font-weight: bold;
    }
  }
`;
export { DropdownStyle, Block };
